import React from 'react';
import './CardContainer.css';
import SmallTextCards from './SmallTextCards'; // Import the CardWithHeader component
import { Container, Row, Col } from 'react-bootstrap';

const CardContainer = ({ cardData }) => {
  const themes = [
    '#4e4187',
    '#d3186a',
    '#157f87',
    '#8dc200',

  ]
  return (
    <div className='card-container'>
      <Container fluid>
        <Row>
      {cardData.map((data, index) => (
        <Col style={{minHeight: "550px"}}>
        <SmallTextCards key={index} header={data.head} text={data.text} variant={themes[index]}/>
        </Col>

      ))}
      </Row>
      </Container>
    </div>
  );
};

export default CardContainer;